<script setup>
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  confirmLabel: {
    type: String,
    default: '',
  },
  isDeleting: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['confirm']);
const dialogRef = ref(null);

const open = () => {
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    width="sm"
    :title="title"
    :description="description"
    :confirm-button-label="confirmLabel"
    :is-loading="isDeleting"
    :disable-confirm-button="isDeleting"
    @confirm="emit('confirm')"
  >
    <p
      v-if="error"
      class="text-sm text-n-ruby-9"
      data-testid="folder-delete-error"
    >
      {{ error }}
    </p>
  </Dialog>
</template>
